/// <amd-module name="Core/Medius.Core.Web/Scripts/shared/mediaService"/>
export function getImageUrl(imageHash: string, imageType: string) {
    if (!imageHash || !imageType) {
        return undefined;
    }
    return `Backend/Rest/MediaService/image/${imageHash}/png/pages/1?tag=${imageType}`;
}